"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cropper = void 0;
// tslint:disable-next-line:no-implicit-dependencies
require("cropperjs/dist/cropper.css");
var React = require("react");
var react_cropper_1 = require("react-cropper");
var Icons_1 = require("../../../Icons");
var Localization_1 = require("../../../Localization");
var Cropper_styles_1 = require("./Cropper.styles");
var Image_1 = require("./Image");
var Slider_1 = require("./Slider");
/*
    this class specifically uses refs and forward refs instead of state,
    to stop the ReactCropper control from being recreated
    this was seen to cause performance problems with large images.
*/
var Cropper = /** @class */ (function (_super) {
    __extends(Cropper, _super);
    function Cropper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.positionIndicatorRef = React.createRef();
        _this.sliderRef = React.createRef();
        _this.getCroppedCanvas = function () {
            return _this.cropperRef.getCroppedCanvas().toDataURL(_this.props.EncoderImageType, _this.props.EncoderOptions);
        };
        _this.handleZoomChange = function (val) {
            var cropper = _this.cropperRef;
            cropper.zoomTo(val);
        };
        return _this;
    }
    Cropper.prototype.render = function () {
        var _this = this;
        var thisClass = this;
        return (React.createElement(Cropper_styles_1.CropperWrapper, null,
            React.createElement(Cropper_styles_1.ImageWrapper, { onMouseEnter: function () { return _this.positionIndicatorRef.current.style.opacity = "1"; }, onMouseLeave: function () { return _this.positionIndicatorRef.current.style.opacity = "0"; } },
                React.createElement(Image_1.default, null,
                    React.createElement(react_cropper_1.default, { aspectRatio: 1 / 1, cropBoxMovable: false, cropBoxResizable: false, dragMode: "move", guides: false, minCropBoxHeight: 300, ref: function (e) { return _this.cropperRef = e; }, scalable: true, src: this.props.CropImage.src, style: { height: 300, width: 300 }, zoomable: true, ready: function () {
                            // ahh the joys of scoping!
                            var cropper = thisClass.cropperRef;
                            var slider = thisClass.sliderRef.current;
                            var _a = cropper.getImageData(), width = _a.width, naturalWidth = _a.naturalWidth;
                            var currentZoom = width / naturalWidth;
                            cropper.zoomTo(currentZoom);
                            slider.value = "" + currentZoom;
                        }, zoom: function (e) {
                            var slider = thisClass.sliderRef.current;
                            slider.value = e.detail.ratio;
                        } }))),
            React.createElement(Slider_1.default, { ref: this.sliderRef, OnZoomChange: this.handleZoomChange }),
            React.createElement(Cropper_styles_1.RepositionIndicator, { ref: this.positionIndicatorRef, style: { opacity: 0 } },
                React.createElement("span", null, Localization_1.strings.UploadAvatar_Label_DragToReposition),
                React.createElement(Icons_1.RepositionIcon, { Width: "22px", Height: "22px" }))));
    };
    return Cropper;
}(React.Component));
exports.Cropper = Cropper;
